module.exports = __webpack_public_path__ + "img/MOTOR_CENTRIFUGADORA.dcd4aa7c.jpg";